import { render, staticRenderFns } from "./Guidance.vue?vue&type=template&id=da77a2fa&scoped=true&"
import script from "./Guidance.vue?vue&type=script&lang=js&"
export * from "./Guidance.vue?vue&type=script&lang=js&"
import style0 from "./Guidance.vue?vue&type=style&index=0&id=da77a2fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da77a2fa",
  null
  
)

export default component.exports